import { createJSONStorage } from "jotai/utils";

// localStorage is absent under SSR and throws in a browser that blocks site
// data (and in jsdom, whose stub has no setItem), fall back to memory rather
// than take the surface using it down with it.
const memory = new Map<string, string>();
const memoryStorage = {
  getItem: (key: string) => memory.get(key) ?? null,
  setItem: (key: string, value: string) => {
    memory.set(key, value);
  },
  removeItem: (key: string) => {
    memory.delete(key);
  },
};

// jotai calls the getter on every storage event, so the probe runs once: a
// probe write on each event would echo back to the other tabs without end.
export const safeJSONStorage = <T>(probeKey: string) => {
  let chosen: Storage | typeof memoryStorage | null = null;
  return createJSONStorage<T>(() => {
    if (chosen) return chosen;
    try {
      window.localStorage.setItem(probeKey, "1");
      window.localStorage.removeItem(probeKey);
      chosen = window.localStorage;
    } catch {
      chosen = memoryStorage;
    }
    return chosen;
  });
};
